import { render, staticRenderFns } from "./videomostMembersVideo.vue?vue&type=template&id=3b55f168&scoped=true&lang=pug&"
import script from "./videomostMembersVideo.vue?vue&type=script&lang=js&"
export * from "./videomostMembersVideo.vue?vue&type=script&lang=js&"
import style0 from "./videomostMembersVideo.vue?vue&type=style&index=0&id=3b55f168&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b55f168",
  null
  
)

export default component.exports